import axios from "axios";
import CryptoJS from "crypto-js";
import { getAuthString, getStoredUser } from "auth/authStorage";
const secretKey = "GHG@#XX212311XWNHHH$665NG";

function encryptData(data) {
  const jsonString = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(jsonString, secretKey).toString();
  return encrypted;
}

function decryptData(encryptedData) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedString);
}

export const baseUrl = process.env.REACT_APP_BASE_URL;

const instance = axios.create({
  baseURL: baseUrl + "/api/",
  // baseURL: 'https://api.galaxyshipping.com/api/',
  withCredentials: true,
});

instance.interceptors.request.use((request) => {
  const user = getStoredUser();
  const sessionID = getAuthString("sessionId");

  const contentType =
    request.headers["Content-Type"] || request.headers["content-type"];
  if (
    request.data != null &&
    String(contentType).includes("application/json")
  ) {
    request.data = {
      data: encryptData(request.data),
    };
  }

  request.headers = {
    ...(request.headers || {}),
    Accept: "application/json, text/plain, */*",
    ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
    ...(sessionID ? { sessionId: sessionID } : {}),
    timezone: new Date().getTimezoneOffset(),
    route: window.location.pathname,
  };

  return request;
});

instance.interceptors.response.use(
  (response) => {
    if (response && response.data) {
      try {
        response.data = JSON.parse(decryptData(response.data));
      } catch (err) {
        console.error("Failed to decrypt success response:", err.message);
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.data) {
      try {
        error.response.data = JSON.parse(decryptData(error.response.data));
      } catch (err) {
        console.error("Failed to decrypt error response:", err.message);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
